import { FILLED, GLYPHS, type GlyphName } from "@/lib/glyphs";
import type { Hue } from "@/lib/identity";

interface GlyphProps {
  name: GlyphName;
  size?: number;
  /** Paint with this hue's gradient; otherwise uses the current text colour. */
  hue?: Hue;
  strokeWidth?: number;
  color?: string;
  className?: string;
}

export function Glyph({ name, size = 16, hue, strokeWidth = 2.2, color, className }: GlyphProps) {
  const paint = color ?? (hue ? `url(#zh-gr-${hue})` : "currentColor");
  const filled = FILLED.has(name);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      className={className}
      fill={filled ? paint : "none"}
      stroke={filled ? "none" : paint}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flex: "0 0 auto" }}
    >
      <path d={GLYPHS[name]} />
    </svg>
  );
}
